interface AppConfigProps {
  supportedLanguages: string[];
  defaultLanguage: string;
}

export const AppConfigs: AppConfigProps = {
  supportedLanguages: ['en', 'tr'],
  defaultLanguage: 'en',
};
